import { trigger, transition, style, query, animateChild, group, animate } from "@angular/animations";

const hh = 70; // height of header
const speed = '200ms';

const slideToRight = [
	style({ position: 'relative' }),
	query(':enter, :leave', [
		style({
			position: 'absolute',
			zIndex: '10',
			top: `${hh + 10}px`,
			left: '10px',
			height: '1000px',
			width: '100%'
		})
	]),
	query(':enter', [
		style({ left: '100%' })
	], { optional: true }),
	query(':leave', animateChild(), { optional: true }),
	group([
		query(':leave', [
			animate(`${speed} ease-out`, style({ left: '-100%' }))
		], { optional: true }),
		query(':enter', [
			animate(`${speed} ease-out`, style({ left: '10px' }))
		], { optional: true }),
	]),
]

const slideToLeft = [
	style({ position: 'relative' }),
	query(':enter, :leave', [
		style({
			position: 'absolute',
			zIndex: '10',
			top: `${hh + 10}px`,
			left: '10px',
			height: '1000px',
			width: '100%'
		})
	]),
	query(':enter', [
		style({ left: '-100%' })
	], { optional: true }),
	query(':leave', animateChild(), { optional: true }),
	group([
		query(':leave', [
			animate(`${speed} ease-out`, style({ left: '100%' }))
		], { optional: true }),
		query(':enter', [
			animate(`${speed} ease-out`, style({ left: '10px' }))
		], { optional: true }),
	]),
]

const slideToBottom = [
	style({ position: 'relative' }),
	query(':enter, :leave', [
		style({
			position: 'absolute',
			zIndex: '10',
			top: `${hh + 10}px`,
			left: '10px',
			height: '1000px',
			width: '100%'
		})
	]),
	query(':enter', [
		style({ top: '100%' })
	], { optional: true }),
	query(':leave', animateChild(), { optional: true }),
	group([
		query(':leave', [
			animate(`${speed} ease-out`, style({ top: '-50%' }))
		], { optional: true }),
		query(':enter', [
			animate(`${speed} ease-out`, style({ top: '0' }))
		], { optional: true }),
	]),
]

const slideToTop = [
	style({ position: 'relative' }),
	query(':enter, :leave', [
		style({
			position: 'absolute',
			zIndex: '10',
			top: `${hh + 10}px`,
			left: '10px',
			height: '1000px',
			width: '100%'
		})
	]),
	query(':enter', [
		style({ top: '-100%' })
	], { optional: true }),
	query(':leave', animateChild(), { optional: true }),
	group([
		query(':leave', [
			animate(`${speed} ease-out`, style({ top: '100%' }))
		], { optional: true }),
		query(':enter', [
			animate(`${speed} ease-out`, style({ top: '0' }))
		], { optional: true }),
	]),
]

export const slideInAnimation = trigger('routeAnimations', [

	transition('HomePage => InnerPage', slideToRight),
	transition('InnerPage => LastPage', slideToRight),
	transition('InnerPage => HomePage', slideToLeft),
	transition('InnerPage => SubPage', slideToBottom),
	transition('SubPage => *', slideToTop),

	transition('* <=> *', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				zIndex: '10',
				top: `${hh + 10}px`,
				left: '10px',
				height: '1000px',
				width: '100%'
			})
		], { optional: true }),
		query(':enter', [
			style({ left: '-100%' })
		], { optional: true }),
		query(':leave', animateChild(), { optional: true }),
		group([
			query(':leave', [
				animate(`${speed} ease-out`, style({ left: '100%', opacity: 0 }))
			], { optional: true }),
			query(':enter', [
				animate(`${speed} ease-out`, style({ left: '10px' }))
			], { optional: true }),
			query('@*', animateChild(), { optional: true })
		]),
	])
]);